import { OwaDate, owaDate } from './owaDate';
import isEqual from 'owa-datetime/lib/owaDate/isEqual';
import startOfWeek from 'owa-datetime/lib/owaDate/startOfWeek';

export default (left: OwaDate, right: OwaDate, weekStartsOn: number) =>
    isEqual(startOfWeek(left, weekStartsOn), startOfWeek(owaDate(left.tz, right), weekStartsOn));
